import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { MessagesModule }                from '../../app-lite/messages/messages.module';
import { PasswordsService }              from './passwords.service';
import { PasswordsStates }               from './passwords.states';
import { RequestPasswordResetComponent } from './password.request-reset.component';
import { ResetPasswordComponent }        from './password.reset.component';
import { SharedModule }                  from '../../app-lite/shared/shared.module';

@NgModule({
  declarations: [
    RequestPasswordResetComponent,
    ResetPasswordComponent
  ],
  entryComponents: [
    RequestPasswordResetComponent,
    ResetPasswordComponent
  ],
  imports: [
    MessagesModule,
    SharedModule,

    UIRouterModule.forChild({ states: PasswordsStates })
  ],
  providers: [
    PasswordsService
  ]
})
export class PasswordsModule {}
